import {ContainerAlert, ContainerAlertEntity} from "../../../model/container-alert";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type ContainerAlertSelectorProps = {
    // selector props here
};

export const containerAlertSelector = () => createSelector(
    [getUseQueryResultData<ContainerAlert>],
    (data) => {
        return data ? transformContainerAlert(data) : undefined;
    }
);

export const containerAlertsSelector = () => createSelector(
    [getUseQueryResultData<ContainerAlert[]>],
    (data) => {
        return selectContainerAlertsAndTransform(
            data ?? [], {}
        );
    }
);

export const transformContainerAlert = (value: ContainerAlert): ContainerAlertEntity => {
    return ContainerAlertEntity.from(value)
}

export const selectContainerAlerts = (values?: ContainerAlert[], selector?: ContainerAlertSelectorProps): ContainerAlert[] => {
    if (!values) {
        return [];
    }

    return values.filter((v) => {
        let filterIn = true;
        return filterIn;
    });
};

export const selectContainerAlertsAndTransform = (values?: ContainerAlert[], selector?: ContainerAlertSelectorProps): ContainerAlertEntity[] => {
    const selected = selectContainerAlerts(values, selector);
    return selected.map(transformContainerAlert);
};
